import { FETCH_SCHEDULES, FETCH_SCHEDULES_DONE, FETCH_SCHEDULES_ERR, EDIT_SCHEDULES, EDIT_SCHEDULES_DONE, EDIT_SCHEDULES_ERR } from './actionTypes';
export const fetchSchedules = () => ({ type: FETCH_SCHEDULES });
export const doneFetchingSchedules = (data) => ({
    type: FETCH_SCHEDULES_DONE,
    data
});
export const errorFetchingSchedules = (data) => ({
    type: FETCH_SCHEDULES_ERR,
    errorMessage: data
});
export const editSchedules = (data) => ({
    type: EDIT_SCHEDULES,
    data
});
export const editSchedulesDone = (data) => ({ type: EDIT_SCHEDULES_DONE, data });
export const editSchedulesError = (data) => ({
    type: EDIT_SCHEDULES_ERR,
    errorMessage: data
});
//# sourceMappingURL=actionCreators.js.map